import React from 'react';
import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<h2>ICSE Board</h2>

<p>St. Andrews World School, Indirapuram is affiliated with the Council for the Indian School Certificate Examinations (CISCE) and follows the ICSE curriculum. The ICSE board is known for its balanced, comprehensive and rigorous academic framework that emphasises deep understanding, critical thinking and the holistic development of every learner.</p>

<h3>Why Choose the ICSE Curriculum?</h3>

<ul>
<li>Broad and balanced curriculum covering languages, sciences, humanities and the arts</li>
<li>Strong emphasis on analytical thinking, problem-solving and application-based learning</li>
<li>Project work and practicals that build real-world skills and confidence</li>
<li>International recognition for higher education across India and abroad</li>
<li>Encourages creativity, communication and independent learning</li>
</ul>

<h3>A Future-Ready Approach</h3>

<p>At St. Andrews World School, the ICSE curriculum is delivered through modern, technology-enabled classrooms and a child-centric approach. Our dedicated educators ensure that every student is nurtured academically, emotionally and socially — preparing them not just for examinations, but for life.</p>`;

const IcseBoard = () => {
  const title = 'ICSE Board';
  const pageData = usePage('icse-board', { content: DEFAULT_CONTENT });

  return (
    <>
      <SEO
        slug="icse-board"
        title={title}
        description="St. Andrews World School, Indirapuram follows the ICSE curriculum with a holistic, balanced and future-ready approach to learning."
        keywords="ICSE board, ICSE curriculum, CISCE school Indirapuram, St Andrews World School, Indirapuram"
      />

      <section className="page-hero">
        {!pageData.loading && (
          <img
            src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/curricullam-infrastructure.jpg'}
            alt={title}
            className="page-hero-img"
            loading="eager"
          />
        )}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner" />
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default IcseBoard;